#import "./LocalizedStringFull.graphql"

fragment PublicCourseTermFull on PublicCourseTerm {
  id
  courseType
  additionalInfo {
    ...LocalizedStringFull
  }
  placeName
  placeUrl
  startsAt
  endsAt
  capacity
  participantsCount
}
